import { QueryClient, hashKey } from '@tanstack/react-query';
import useAuthStore, { selectPrincipal } from 'stores/authStore';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5,
      retry: 1,
      // Defense in depth: an entry is addressed by principal as well as by key,
      // so the same key read as another user or tenant is a different entry.
      queryKeyHashFn: (queryKey) =>
        hashKey([selectPrincipal(useAuthStore.getState()), ...queryKey]),
    },
  },
});

/** Drop everything cached for the previous principal, in-flight fetches included. */
export function resetQueryCache() {
  queryClient.cancelQueries();
  queryClient.clear();
}

// Every change of principal goes through the auth store — logout on any path
// (the account menu, the 401 interceptor, a direct store.logout()), a tenant switch, a
// login or accepted invite that replaces the session — so reset the cache there.
useAuthStore.subscribe((state, prev) => {
  if (selectPrincipal(state) !== selectPrincipal(prev)) resetQueryCache();
});

export default queryClient;
